import { render } from "./Contact.vue?vue&type=template&id=f1ee8998&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=f1ee8998&scoped=true&lang=css"

import exportComponent from "/home/runner/work/motokandemir-web/motokandemir-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ee8998"]])

export default __exports__